<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/activityManagement' }">
          <a>活动管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>活动用户列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='用户信息'>
            <el-input
              clearable
              style="width:500px"
              v-model="filters.keyword"
              placeholder="请输入用户信息搜索"
            >
            </el-input>
          </el-form-item>
          
          <el-form-item>
            
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button> 

            <el-button
              type="primary"
              @click="sendNum"
            >赠送数量</el-button> 
            
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        {{showMsg}}
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          
          <el-table-column
            label="姓名"
            prop="username"
          >
          <template slot-scope="scope">
            <a
              style="color:blue;cursor: pointer;"
              @click="goDetail(scope.row)"
            >{{scope.row.username}}</a>
          </template>
          </el-table-column>

          <el-table-column
            label="手机号"
            prop="telephone"
          >
          </el-table-column>

          <el-table-column
            label="参与订单"
            prop="telephone"
          >
            <template slot-scope="scope">
            <el-button @click="showOrder(scope.row, 1)" type="text">查看</el-button>
          </template>
          </el-table-column>

          <el-table-column
            label="特权订单"
            prop="telephone"
          >
          <template slot-scope="scope">
            <el-button @click="showOrder(scope.row, 2)" type="text">查看</el-button>
          </template>
          </el-table-column>

          <el-table-column
            label="剩余数量"
            prop="num"
          >
          <template slot-scope="scope">
            <el-button @click="showDetailInfos(scope.row)" type="text">{{scope.row.num}}</el-button>
          </template>
          </el-table-column>

          <!-- <el-table-column
            label="历史总数"
            prop="used_num"
          >
          </el-table-column> -->

          <!-- <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              
              <el-button v-if="hasPower('20051991')"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑数量</el-button>
              
            </template>
          </el-table-column> -->
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="参与订单"
      :visible.sync="subListVisible1"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading1"
        :data="tableDetailData1"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >

        <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="order_code"
            label="订单号"
          >
          <template slot-scope="scope">
            <router-link
                target="_blank"
                :to="{path:'/orderDetail',query:{orderId:scope.row.id}}"
              >{{scope.row.order_code}}</router-link>
          </template>
          </el-table-column>

          <el-table-column
            prop="send_name"
            v-if="acSeType == 1"
            label="发货人"
          >
          </el-table-column>

          <el-table-column
            prop="total_money"
            label="总金额"
          >
          </el-table-column>

          <el-table-column
            prop="score_price"
            label="总积分"
          >
          </el-table-column>
          <!-- :show-overflow-tooltip="true" -->
          <el-table-column
            prop="create_time"
            label="下单时间"
          >
          </el-table-column>
          <el-table-column
            prop="order_type"
            :formatter="formatterOrderType"
            label="订单类型"
          >
          </el-table-column>

          <el-table-column
            prop="postage_status"
            v-if="acSeType == 1"
            label="包邮状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.postage_status == 1"
                type="success"
                disable-transitions
              >包邮</el-tag>
              <el-tag
                v-if="scope.row.postage_status == 2"
                type="info"
                disable-transitions
              >不包邮</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="postage_type"
            v-if="acSeType == 1"
            label="送货类型"
            width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.postage_type == 1"
                type="success"
                disable-transitions
              >自提</el-tag>
              <el-tag
                v-if="scope.row.postage_type == 2"
                type="success"
                disable-transitions
              >快递</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            v-if="acSeType == 1"
            prop="province"
            label="地址信息 "
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{scope.row.add_name }} {{scope.row.add_tel }} {{scope.row.province }}{{scope.row.city }}{{scope.row.district }}{{scope.row.address_detail }}
            </template>
          </el-table-column>


          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>

          <el-table-column
            prop="order_info"
            label="订单备注"
          >
          </el-table-column>

          <el-table-column
            v-if="acSeType == 1"
            prop="send_time1"
            label="发货时间"
            width="100"
          >
          </el-table-column>

          <el-table-column
            prop="no_vip"
            label="是否是耗材"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.no_vip == 1"
                type="success"
                disable-transitions
              >不是</el-tag>
              <el-tag
                v-if="scope.row.no_vip == 2"
                type="warn"
                disable-transitions
              >是</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            v-if="acSeType == 1"
            prop="printStatus"
            label="是否打印"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.printStatus == 1"
                type="success"
                disable-transitions
              >不是</el-tag>
              <el-tag
                v-if="scope.row.printStatus == 2"
                type="warn"
                disable-transitions
              >是</el-tag>
            </template>
          </el-table-column>
      </el-table>

      <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange2"
            :current-page.sync="page_num2"
            :page-count='total_page2'
            :page-size="page_size2"
            layout="total, prev, pager, next"
            :total="total_num2"
          >
          </el-pagination>
        </div>

    </el-dialog>

    <el-dialog
      title="特权明细"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >

        <el-table-column
          prop="username"
          label="数量"
        >
        </el-table-column>

        <el-table-column
          prop="create_time"
          label="时间"
        >
        </el-table-column>

        <el-table-column
          prop="typeName"
          label="类型"
        >
        </el-table-column>

        <el-table-column
          prop="num"
          label="数量"
        >
        </el-table-column>
      </el-table>

      <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page.sync="page_num1"
            :page-count='total_page1'
            :page-size="page_size1"
            layout="total, prev, pager, next"
            :total="total_num1"
          >
          </el-pagination>
        </div>

    </el-dialog>

    <el-dialog
      title="赠送数量"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="数量"
          prop='num'
        >
          <el-input type='number' v-model="form.num"></el-input>
        </el-form-item>

        <el-form-item
          label="手机号"
          prop='telephone'
        >
          <el-input type='number' v-model="form.telephone"></el-input>
        </el-form-item>

        <el-form-item
          label="商品id"
          prop='goodId'
        >
          <el-input type='number' v-model="form.goodId"></el-input>
        </el-form-item>

        
        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
export default {
  name: "judgeTypeList",
  watch:{
    $route(){
      if (this.$route.query.acId && this.$route.query.acId != null && this.$route.query.acId != this.activityId) {
        console.log('进来：' + this.$route.query.acId)
        this.tableHeight = document.documentElement.clientHeight - 330;
        this.page_num = 1;
        this.activityId = this.$route.query.acId;
        this.infoType = this.$route.query.infoType;
        this.activityName = this.$route.query.acName;
        this.handleSearch();
        this.getCount();  
      } else {
        console.log('进来1：' + this.$route.query.acId)
      }
    },
  },
  created() {
    
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.activityId = this.$route.query.acId;
    this.infoType = this.$route.query.infoType;
    this.activityName = this.$route.query.acName;
    this.handleSearch();
    this.getCount();
  },

  data() {
    return {
      showMsg:'',
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        num: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        telephone: [
          { required: true, message: "请输入用户手机号", trigger: "blur" }
        ],
      },
      addLoading: false,
      loading: false,
      form: {
        infoType:2,
        status: null,
        typeName: null,
        pid: null,
        mainPic: null,
        listPic: null,
        goodId:null,
        num:null,
        telephone:null,
        id: null
      },
      dialogPics: [],
      acSeType:1,
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      tableDetailData1:[],
      tableDetailData:[],
      filters: {
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      backFirst: 1,
      detailListLoading:false,
      detailListLoading1:false,
      page_num: 1,
      keywords: "",
      subListVisible:false,
      subListVisible1:false,
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      page_size1:10,
      page_num1:1,
      total_num1: 0,
      total_page1: 0,
      userId:null,
      page_size2:10,
      page_num2:1,
      total_num2: 0,
      total_page2: 0,
      total_num: 0,
      activityId:null,
      total_page: 0,
      page_size: 10,
      infoType:null,
      tableHeight:null
    };
  },
  mounted() {
    
  },
  methods: {
    sendNum(){
      this.form.num = null;
      this.form.goodId = null;
      this.form.telephone = null;
      this.dialogEditVisible = true;
    },
    formatterOrderType(row, column) {
      if (row.order_type == 1) {
        return "发货订单";
      } else if (row.order_type == 2) {
        return "购进订单";
      } else if (row.order_type == 3) {
        return "待补货订单";
      } else if (row.order_type == 4) {
        return "已补货订单";
      }
    },
    
    formatterStatus(row, column) {
      if (row.status == 1) {
        return "待支付";
      } else if (row.status == 2) {
        return "待发货";
      } else if (row.status == 3) {
        return "待收货";
      } else if (row.status == 4) {
        return "已完成";
      } else if (row.status == 5) {
        return "已取消";
      } else if (row.status == 7) {
        return "待自提";
      } else if (row.status == 8) {
        return "已自提";
      } else if (row.status == 9) {
        return "待补货";
      } else if (row.status == 10) {
        return "补货待支付";
      } else if (row.status == 11) {
        return "补货已完成";
      } else if (row.status == 12) {
        if (row.expire_type == null) {
          return "补货已过期";
        } else {
          if (row.expire_type == 1) {
            return "超时未支付过期";
          } else if (row.expire_type == 2) {
            return "超时未补货过期";
          }
        }
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    showOrder(row, infoType) {
      let that = this;
      that.subListVisible1 = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.userId = row.user_id;
      this.acSeType = infoType == 1 ? (that.infoType == 1 ? 1 : 2) : 3;
      this.searchOrder();
    },
    searchOrder() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        acId: that.activityId,
        userId: that.userId,
        acType:that.acSeType,
        pageNum: that.page_num2,
        pageSize: that.page_size2
      };
      that.detailListLoading1 = true;
      API.order_list(para)
        .then(
          function(result) {
            that.detailListLoading1 = false;
            that.total_num2 = result.result.count;
            that.total_page2 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].send_time != null)
                  {
                    result.result.list[i].send_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].send_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  }
                }
                that.tableDetailData1 = result.result.list;
              } else {
                that.tableDetailData1 = [];
              }
            }
          },
          function(err) {
            that.detailListLoading1 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    showDetailInfos(row, type) {
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.userId = row.user_id;
      this.searchDetail();
    },
    goDetail(row) {
      this.$router.push({ path: "/user_detail", query: { id: row.user_id, back: 2, acId:this.activityId, acName:this.activityName } });
    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        activityId: that.activityId,
        userId: that.userId,
        pageNum: that.page_num1,
        pageSize: that.page_size1
      };
      that.detailListLoading = true;
      API.activity_user_num_history_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num1 = result.result.count;
            that.total_page1 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableDetailData = result.result.list;
                that.tableDetailData.forEach(items => {
                  items.create_time = dateFunc.formatDate(
                    new Date(parseInt(items.create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (items.info_type == 1)
                  {
                    items.typeName = '发货购进获得';
                  } else if (items.info_type == 2)
                  {
                    items.typeName = '购进使用';
                  } else if (items.info_type == 3)
                  {
                    items.typeName = '后台新增';
                  } else if (items.info_type == 4)
                  {
                    items.typeName = '后台扣除';
                  }
                })
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    editPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.up_activity_user_good_num_new({token:localStorage.getItem("api_token"), activityId:that.activityId, num:para.num, telephone:para.telephone,  goodId: para.goodId})
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.dialogEditVisible = false;
                  that.addLoading = false;
                  that.search();
                } else if (result.key == 1001) {
                  that.addLoading = false;
                  bus.$emit("goto", "/login");
                } else {
                  that.addLoading = false;
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogEditVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogEditVisible = false;
              console.log(error);
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    editPostDialog(row) {
      this.form.id = row.id;
      this.form.userId = row.user_id;
      this.form.typeName = row.num;
      this.dialogEditVisible = true;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    getCount(){
      
      let that = this;
      let params = {
        activityId: that.activityId,
        infoType:that.infoType,
        token: localStorage.getItem("api_token")
      };      
        // API.activity_count_info(params)
        //   .then(
        //     function(result) {
        //       that.loading = false;
        //       if (result.key == 1000) {
        //         var show = '参与用户：' + result.result.map.userNum + '人；';
        //         if (that.infoType == 1)
        //         {
        //           show += '总发货数量：' + result.result.map.buyNum + '件；';
        //         } else if (that.infoType == 2)
        //         {
        //           show += '总购进数量：' + result.result.map.buyNum + '件；';
        //         } else if (that.infoType == 3)
        //         {
        //           show += '总购进金额：' + result.result.map.buyNum + '元；';
        //         }
        //          show += '特权使用：' + result.result.map.useNum + '件；';
        //          that.showMsg = show;
        //       } else if (result.key == 1001) {
        //         bus.$emit("goto", "/login");
        //       }
        //     },
        //     function(err) {
        //       that.loading = false;
        //       that.$message.error({
        //         showClose: true,
        //         message: err.toString(),
        //         duration: 2000
        //       });
        //     }
        //   )
        //   .catch(function(error) {
        //     that.loading = false;
        //     console.log(error);
        //     that.$message.error({
        //       showClose: true,
        //       message: "请求出现异常",
        //       duration: 2000
        //     });
        //   });
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        activityId: that.activityId,
        token: localStorage.getItem("api_token")
      };
      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.keyword = that.filters.keyword;
      }
      that.loading = true;
      
        API.activity_user_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.total_num = result.result.count;
                that.total_page = result.result.allPageNumber;
                if (result.result.list && result.result.list.length > 0) {
                }
                that.tableData = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    handleCurrentChange1(val) {
      this.searchDetail();
    },
    handleCurrentChange2(val) {
      this.searchOrder();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/acUserList.vue